/** @format */

// !!! Важно, чтобы этот список соответствовал всем значениям в ChartIds
// Список по возможности должен быть разбит на категории

import {ChartIds} from '../models/chartIds';
import {ComplexValueId} from '../models/common';

export const ALL_BUDGET_CHART_IDS: ChartIds[] = ['budget'];

export const ALL_SENSOR_CHART_IDS: ChartIds[] = ['sensorRed', 'sensorYellow', 'sensorGray'];

export const ALL_SCATTER_IDS: ChartIds[] = ['notes', 'logs'];

// Основные показатели, которые могут быть KPI
export const ALL_PROPERTY_IDS: ChartIds[] = [
  'cpl',
  'drr',
  'romi',
  'income',
  'clicks',
  'cpc',
  'shows',
  'cpm',
  'avgVideoCompleteCost',
  'reach',
  'vtr',
  'ctr',
  'er',
  'declines',
  'conversions',
  'videoComplete',
  'engagement',
  'bounces',
  'sessions',
];

export const ALL_STUB_CHART_IDS: ChartIds[] = [
  'stub_weather',
  'stub_seasonality',
  'stub_price_index',
  'stub_cb_rate',
  'stub_currency',
];

export const ALL_CHART_IDS: ChartIds[] = [
  ...ALL_PROPERTY_IDS,
  ...ALL_BUDGET_CHART_IDS,
  ...ALL_SENSOR_CHART_IDS,
  ...ALL_SCATTER_IDS,
  ...ALL_STUB_CHART_IDS,
];

export const ALL_COMPLEX_VALUES: ComplexValueId[] = [
  'clicks',
  'revenue',
  'videoComplete',
  'engagement',
  'conversions',
  'reach',
  'impressions',
  'bounces',
  'sessions',
  'spent',
];
